
<template>
  <el-card style="height: 83vh">
    <el-table :data="tableData" border
              style="width: 100%;height: 74vh">
      <el-table-column prop="dataType" label="数据类型" align="center" min-width="120px">
        <template v-slot="scope">
          <el-tag v-if="scope.row.dataType === 'noteRecord'">笔记数据</el-tag>
          <el-tag v-if="scope.row.dataType === 'redBook'">小红书数据</el-tag>
          <el-tag v-if="scope.row.dataType === 'weibo'">微博数据</el-tag>
          <el-tag v-if="scope.row.dataType === 'toutiao'">头条数据</el-tag>
          <el-tag v-if="scope.row.dataType === 'spu'">客户分析-SPU数据</el-tag>
          <el-tag v-if="scope.row.dataType === 'advertisingRevenue'">客户分析-广告流水</el-tag>
          <el-tag v-if="scope.row.dataType === 'mediaAnalysis'">媒介-客户分析</el-tag>
          <el-tag v-if="scope.row.dataType === 'opGroupRecordKeys'">现金消耗(天)</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="dataNum" label="上传数量" align="center"/>
      <el-table-column prop="dataTotal" label="总金额" align="center"/>
      <el-table-column prop="importTime" label="上传数据时间" align="center">
        <template v-slot="scope">
          {{ $filters.dateFilter(scope.row.importTime)  }}
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="上传人" align="center"/>
      <el-table-column label="操作" width="260px" fixed="right" align="center">
        <template v-slot="scope">
          <el-button type="primary" @click="handleSure(scope.row.dataFlag)" :disabled="scope.row.status === 1">确认</el-button>
          <el-button type="danger" @click="handleDelete(scope.row.dataFlag)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="height: 5vh"
    >
    </el-pagination>
  </el-card>
</template>

<script setup>
import { deleteDataByBatchId, getNotSure, sureDataByBatchId } from '@/api/data-sure'
import { onMounted, onUnmounted, ref } from 'vue'
import utils from '@/utils/utils'

const tableData = ref([])
const total = ref(0)
const page = ref(1)
const size = ref(20)
const getNotSureList = async () => {
  const result = await getNotSure({
    page: page.value,
    size: size.value
  })
  tableData.value = result.list
  total.value = result.total
}
getNotSureList()

/**
 * 确认数据正确
 */
const handleSure = async (batchId) => {
  utils.showLoadding()
  const result = await sureDataByBatchId({
    batchId: batchId
  })
  if (result) {
    await getNotSureList()
  }
  utils.hideLoadding()
}

const handleDelete = async (batchId) => {
  utils.showLoadding()
  const result = await deleteDataByBatchId({
    batchId: batchId
  })
  if (result) {
    await getNotSureList()
  }
  utils.hideLoadding()
}

onMounted(() => {
  const handleStorage = (e) => {
    if (e.key === 'uploadedSuccess' && e.newValue) {
      getNotSureList() // 或调用你的刷新数据方法
    }
  }
  window.addEventListener('storage', handleStorage)

  onUnmounted(() => {
    window.removeEventListener('storage', handleStorage)
  })
})

/**
 * size 改变触发
 */
const handleSizeChange = currentSize => {
  size.value = currentSize
  getNotSureList()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = currentPage => {
  page.value = currentPage
  getNotSureList()
}

</script>

<style scoped lang="scss">

</style>
